import { useContext } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import WorkOrderAssetView from '@atom/components/common/workOrderDetail/workOrderAssetView/WorkOrderAssetView';
import WorkOrderContext from '@atom/components/workOrderDetail/WorkOrderContext';

import TaskDetailView from './taskDetailView/TaskDetailView';
import TaskList from './TaskList';

import classes from './workOrderTasks.module.css';

const WorkOrderTasks = () => {
  const {
    workOrderDetail,
    workOrderAsset,
    task,
    setActiveWorkOrderAsset,
    refetchWorkOrderAssetTreeLoading,
    refetchWorkOrderAssetTree,
    refetch,
  } = useContext(WorkOrderContext);

  const isTaskView = R.isEmpty(workOrderAsset) || R.isNil(workOrderAsset);
  const displayTaskDetail = !R.isNil(task) && !R.isEmpty(task);

  return (
    <div className={classes.tasksContainer}>
      {isTaskView ? (
        <>
          <div className={clsx(classes.pane, classes.left)}>
            <TaskList />
          </div>
          <div className={clsx(classes.pane, classes.right)}>
            {displayTaskDetail && <TaskDetailView />}
          </div>
        </>
      ) : (
        <WorkOrderAssetView
          workOrderDetail={workOrderDetail}
          workOrderAsset={workOrderAsset}
          setActiveWorkOrderAsset={setActiveWorkOrderAsset}
          refetchWorkOrderAssetTreeLoading={refetchWorkOrderAssetTreeLoading}
          refetchWorkOrderAssetTree={refetchWorkOrderAssetTree}
          refetch={refetch}
          taskId={task.id}
        />
      )}
    </div>
  );
};

export default WorkOrderTasks;
